// Paleta fixa de ícones para campos personalizados.
// SiteUP V2 (F1.2e): catálogo em Remix (`i-ri-*`). As classes precisam aparecer
// LITERALMENTE aqui para o Tailwind/JIT (@egoist/tailwindcss-icons) gerar o CSS
// — classes montadas em runtime (ex.: `i-ri-${nome}`) não seriam geradas. Por
// isso guardamos/salvamos a classe completa.
//
// O que já está salvo em `custom_attribute_definitions.icon` continua em
// `i-lucide-*` e NÃO foi migrado: é traduzido na leitura por
// `resolveSavedIconClass` (dashboard/helper/legacyIconClass.js).
export const CUSTOM_ATTRIBUTE_ICON_OPTIONS = [
  'i-ri-star-line',
  'i-ri-heart-line',
  'i-ri-flag-line',
  'i-ri-price-tag-line',
  'i-ri-bookmark-line',
  'i-ri-bell-line',
  'i-ri-calendar-2-line',
  'i-ri-time-line',
  'i-ri-mail-line',
  'i-ri-phone-line',
  'i-ri-map-pin-line',
  'i-ri-globe-line',
  'i-ri-user-line',
  'i-ri-group-line',
  'i-ri-building-2-line',
  'i-ri-briefcase-line',
  'i-ri-money-dollar-box-line',
  'i-ri-bank-card-line',
  'i-ri-shopping-cart-line',
  'i-ri-box-1-line',
  'i-ri-link',
  'i-ri-hashtag',
  'i-ri-information-line',
  'i-ri-checkbox-circle-line',
  'i-ri-alert-line',
  'i-ri-hand-heart-line',
  'i-ri-thumb-up-line',
  'i-ri-flashlight-line',
];
